import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js';
import { Box3, Object3D, Vector3 } from 'three';

export function lookAtTarget(controls: OrbitControls, target: Object3D): void {
  // Adjust orbit controls to look at target
  const bb = new Box3().setFromObject(target);
  const lookAtPosition = new Vector3();
  bb.getCenter(lookAtPosition);
  controls.target.set(lookAtPosition.x, lookAtPosition.y, lookAtPosition.z);
  // Constraining the polar and azimuth angle during the update() call, preserves the camera rotation at polar angles
  const polar = controls.getPolarAngle();
  const azimuth = controls.getAzimuthalAngle();
  controls.minAzimuthAngle = azimuth;
  controls.maxAzimuthAngle = azimuth;
  controls.minPolarAngle = polar;
  controls.maxPolarAngle = polar;
  controls.update();
  controls.minAzimuthAngle = -Infinity;
  controls.maxAzimuthAngle = Infinity;
  controls.minPolarAngle = 0;
  controls.maxPolarAngle = Math.PI;
}
